import { HeroThankYouProps } from '@payfit/growth-platform-brand-system-v2/templates/HeroThankYou';
import { ButtonV2 } from 'libs/growth-platform-brand-system-v2/src/components/ButtonV2';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import { ButtonTracking } from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import { createSchema, morphism } from 'morphism';
import React from 'react';
import { schemaDatoButton } from '../schemaDatoButton';

export const schemaHeroThankYou = createSchema<HeroThankYouProps, any>({
  title: 'title',
  subtitle: 'subtitle',
  ctaButtons: {
    path: ['ctaButton', 'locale'],
    fn: ({ ctaButton, locale }: any) => {
      if (ctaButton) {
        const btns = ctaButton.reduce((acc: any[], btn: any, key: number) => {
          if (btn?.href?.includes('app.payfit.live')) {
            const cta = morphism(schemaDatoButton, {
              ...btn,
              className: 'w-full md:w-auto hidden lg:flex',
              size: 'big',
              locale,
            });

            acc.push(
              <ButtonTracking
                component={ButtonV2}
                index={key}
                section="HeroThankYou"
                {...cta}
                labelTracking={cta.title}
                key={key}
              />,
            );
          } else {
            const cta = morphism(schemaDatoButton, {
              ...btn,
              className: classNames('w-full', 'md:w-auto'),
              size: 'big',
              locale,
            });
            acc.push(
              <ButtonTracking
                component={ButtonV2}
                index={key}
                section="HeroThankYou"
                {...cta}
                labelTracking={cta.title}
                key={key}
              />,
            );
          }

          return acc;
        }, []);

        return btns;
      }
      return;
    },
  },
});
